"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("../typography/index");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const BottomTabsBar = ({ children, router }) => (core_1.jsx("nav", { className: styles_scss_1.default.bottomTabsBar }, React.Children.map(children, (c) => React.cloneElement(c, {
    router,
}))));
BottomTabsBar.defaultProps = {};
const Tab = ({ router, label, color, activeColor, icon, to }) => {
    const { location } = router;
    const active = lodash_1.includes(location.pathname, to);
    return (core_1.jsx("div", { className: styles_scss_1.default.tab, css: styles_1.default.tab(active, color, activeColor) },
        core_1.jsx(react_router_dom_1.Link, { to: to },
            core_1.jsx("img", { src: active ? icon.active : icon.default, "aria-label": `bottom-tab-${label}` }),
            core_1.jsx(index_1.HelperText, null, label),
            active && core_1.jsx("div", { className: styles_scss_1.default.selectionCircle }))));
};
Tab.defaultProps = {
    color: styles_scss_1.default.tertiary,
    activeColor: styles_scss_1.default.primary,
    router: undefined
};
BottomTabsBar.Tab = Tab;
const mapStateToProps = (state) => ({
    router: state.router,
});
exports.default = react_redux_1.connect(mapStateToProps, null)(BottomTabsBar);
